import React from "react";
import { useFavoriteStore } from "~/store/favorite";

export function useFavorite(itemId?: string) {
  const favorites = useFavoriteStore((s) => s.items);
  const toggle = useFavoriteStore((s) => s.toggle);
  const add = useFavoriteStore((s) => s.add);
  const remove = useFavoriteStore((s) => s.remove);
  const clear = useFavoriteStore((s) => s.clear);
  const max = useFavoriteStore((s) => s.max);

  const favoritesCount = favorites.length;
  const liked = !!(itemId && favorites.includes(itemId));

  const toggleFavorite = (event?: React.MouseEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (!itemId) return;
    toggle(itemId);
  };

  return {
    favorites,
    favoritesCount,
    liked,
    toggleFavorite,
    add,
    remove,
    clear,
    max,
  };
}